/*
  Moya motion: parallax on photos, a hero that eases away, and content that rises into view.
  Everything is skipped for people who prefer reduced motion, and nothing is hidden until this script runs.
*/
(function () {
  var w = window, d = document;
  if (!('IntersectionObserver' in w) || w.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (d.documentElement.classList.contains('shopify-design-mode') || w.Shopify && w.Shopify.designMode) return;

  var style = d.createElement('style');
  style.textContent = [
    '.moya-px { will-change: translate; }',
    '.moya-rv { opacity: 0; translate: 0 3rem; transition: opacity 0.9s cubic-bezier(0.2, 0.7, 0.2, 1), translate 0.9s cubic-bezier(0.2, 0.7, 0.2, 1); transition-delay: var(--rv-d, 0s); }',
    '.moya-rv.is-in { opacity: 1; translate: 0 0; }',
    '.moya-hero__content { will-change: translate, opacity; }'
  ].join('\n');
  d.head.appendChild(style);

  var mobile = w.matchMedia('(max-width: 749px)').matches;
  var K = mobile ? 0.04 : 0.065; // how far photos drift inside their frames

  // 1. Parallax photos: each image drifts within its frame as the frame passes through the screen
  var PX = ['.moya-media img', '.moya-media video', '.moya-feat__media img', '.moya-art__hero img', '.moya-blog__feat .moya-blog__img img', '.moya-fam__card:not(.moya-fam__card--contain) img'];
  var pxEls = Array.prototype.slice.call(d.querySelectorAll(PX.join(',')));
  var active = new Set();
  pxEls.forEach(function (el) {
    el.classList.add('moya-px');
    el.style.scale = '1.16';
  });
  var pxIo = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var img = e.target._moyaImg;
      if (e.isIntersecting) active.add(img); else active.delete(img);
    });
    requestTick();
  }, { rootMargin: '20% 0px 20% 0px' });
  pxEls.forEach(function (el) { var frame = el.parentElement; frame._moyaImg = el; pxIo.observe(frame); });

  // 2. Hero: the photo or video moves slower than the page, the words ease up and fade
  var hero = d.querySelector('.moya-hero');
  var heroMedia = hero ? Array.prototype.slice.call(hero.querySelectorAll('.moya-hero__media img, .moya-hero__media video')) : [];
  var heroContent = hero ? hero.querySelector('.moya-hero__content') : null;
  heroMedia.forEach(function (el) { el.style.scale = '1.22'; el.classList.add('moya-px'); });

  var ticking = false;
  function requestTick() { if (!ticking) { ticking = true; w.requestAnimationFrame(update); } }
  function update() {
    ticking = false;
    var vh = w.innerHeight, sy = w.pageYOffset;
    if (hero) {
      var hh = hero.offsetHeight;
      if (sy < hh * 1.2) {
        var my = Math.min(sy * 0.18, hh * 0.1);
        heroMedia.forEach(function (el) { el.style.translate = '0 ' + my.toFixed(1) + 'px'; });
        if (heroContent) {
          heroContent.style.translate = '0 ' + (sy * 0.28).toFixed(1) + 'px';
          heroContent.style.opacity = Math.max(0, 1 - sy / (hh * 0.7)).toFixed(3);
        }
      }
    }
    active.forEach(function (img) {
      var r = img.parentElement.getBoundingClientRect();
      var p = ((r.top + r.height / 2) - vh / 2) / vh;
      if (p > 1.2) p = 1.2; else if (p < -1.2) p = -1.2;
      img.style.translate = '0 ' + (-p * r.height * K).toFixed(1) + 'px';
    });
  }
  w.addEventListener('scroll', requestTick, { passive: true });
  w.addEventListener('resize', requestTick);
  update();

  // 3. Reveal: headings, text, cards and bottles rise into place as they come into view, in a gentle stagger
  var RV = [
    '.moya-section .moya-h2', '.moya-section .moya-lede', '.moya-section .moya-actions',
    '.moya-benefit', '.moya-fam__item', '.moya-grp__intro', '.moya-grp__grid > li', '.moya-guide__row > li',
    '.moya-chap', '.moya-cards__card', '.moya-cov__card', '.moya-anat__fig', '.moya-anat__pt', '.moya-logos__item',
    '.moya-steps > li', '.moya-show__grid > li', '.moya-blog__grid > li', '.moya-blog__feat', '.moya-quote figure',
    '.moya-feat__media', '.moya-feat__body', '.moya-split__media', '.moya-eng__stage', '.moya-story2 .moya-media',
    '.moya-story2__features > p', '.moya-sf', '.moya-contact > *', '.moya-formcard', '.moya-methods > li'
  ].join(',');
  var rvAll = Array.prototype.slice.call(d.querySelectorAll(RV)).filter(function (el) {
    return !el.closest('.shopify-section-group-header-group, .shopify-section-group-footer-group, cart-drawer, .moya-side__nav');
  });
  var rvSet = new Set(rvAll);
  // Skip anything already inside another revealing element, so nothing animates twice
  var rvEls = rvAll.filter(function (el) {
    var p = el.parentElement;
    while (p) { if (rvSet.has(p)) return false; p = p.parentElement; }
    return true;
  });
  var counts = new Map();
  rvEls.forEach(function (el) {
    var parent = el.parentElement;
    var i = counts.get(parent) || 0;
    counts.set(parent, i + 1);
    el.style.setProperty('--rv-d', Math.min(i * 0.08, 0.48).toFixed(2) + 's');
    el.classList.add('moya-rv');
  });
  var rvIo = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      rvIo.unobserve(e.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  rvEls.forEach(function (el) { rvIo.observe(el); });
})();
